







































































































































































































































































































































import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
@Component({
  name: "education-modal-component",
})
export default class EducationComponent extends mixins(NotificationEvent) {
  currentPage = 1;
  lastPage = 0;
  loadHistory = false;
  scrollableDiv = null;
  currentPageChats = 1;
  lastPageChats = 0;
  loadChats = false;
  scrollableDivChats = null;
  text = "";
  responseText = [];
  chats = [];
  isAiActivated = true;
  loading = false;
  idChat = null;
  idToday = null;
  idYesterday = null;
  idDays = [];
  name = "";
  description = "";
  idRoom = 0;
  welcome = "";
  image = null;
  questions = [];
  welcomeQuestions = [];
  typingBot = false;
  myExt = () => [
    {
      type: "lang",
      regex: /markdown/g,
      replace: "showdown",
    },
  ];
  mounted() {}
  get active() {
    const e = this.$store.getters["SystemStore/getShowEducationModal"];
    if (e) {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", -1);
      this.$store.dispatch("SystemStore/setShowCameraOptionsAction", false);
      this.$store.dispatch("SidebarStore/setOpenChatAction", false);

      const space = this.$store.getters["SpaceStore/getSpace"];
      if (space) {
        const roomBot = this.$store.getters["SystemStore/getEducationBotId"];
        if (roomBot != 0) {
          const room = space.scenario.rooms.find(
            (element) => element.bot?.id == roomBot
          );
          this.name = room.bot.name;
          this.description = room.bot.description;
          this.welcome = room.bot.welcome;
          this.image = room.bot.image;
          this.idRoom = room.id;
          this.welcomeQuestions = room.bot.questions;
        }
      }
      if (this.currentPageChats == 1) this.getChats();
      setTimeout(() => {
        this.scrollableDiv = document.getElementById("body-scroll");
        this.scrollableDiv.addEventListener("scroll", this.nextPage);
        this.scrollableDivChats = document.getElementById("body-chat-scroll");
        this.scrollableDivChats.addEventListener("scroll", this.nextPageChats);
      }, 500);
    }
    return e;
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setEducationModalAction", e);
  }
  nextPage() {
    if (
      Math.abs(this.scrollableDiv.scrollTop - this.scrollableDiv.clientHeight) +
        100 >=
      this.scrollableDiv.scrollHeight
    ) {
      if (this.loadHistory) return;
      this.loadHistory = true;
      this.currentPage++;
      if (this.currentPage <= this.lastPage)
        this.getChatHistory(this.idChat, false);
    }
  }
  nextPageChats() {
    if (
      Math.abs(
        this.scrollableDivChats.scrollTop + this.scrollableDivChats.clientHeight
      ) +
        50 >=
      this.scrollableDivChats.scrollHeight
    ) {
      if (this.loadChats) return;
      this.loadChats = true;
      this.currentPageChats++;
      if (this.currentPageChats <= this.lastPageChats) {
        this.getChats();
      }
    }
  }
  preventEnter(event): void {
    if (event.keyCode === 13) {
      if (!event.shiftKey) {
        event.preventDefault();
        this.setMessage();
      }
    }
  }
  async getChats() {
    this.loading = true;
    await this.$store.dispatch("HawkingsStore/getChatsAction", {
      roomId: this.idRoom,
      page: this.currentPageChats,
      callback: (response) => {
        this.lastPageChats = parseInt(response.headers["pagination-last-page"]);
        this.loading = false;
        if (this.currentPageChats == 1) {
          this.chats = response.data;
          if (this.chats && this.chats.length > 0) {
            this.idChat = this.chats[0].id;
            this.getChatHistory(this.chats[0].id, false);
          } else {
            if (this.welcome != null && this.responseText.length === 0)
              this.responseText.push({
                message: this.welcome,
                role: "assistant",
                id: -1,
              });
          }
        } else {
          this.chats.push(...response.data);
        }
        setTimeout(() => {
          this.loadChats = false;
        }, 500);
      },
      callbackError: (error) => {
        console.log("TTT getChatsAction KO ", error);
        this.loading = false;
        this.loadChats = false;
      },
    });
  }
  async setMessage() {
    if (this.text.trim().length <= 0) return;
    this.questions = [];
    this.loading = true;
    if (this.idChat == null) {
      await this.$store.dispatch("HawkingsStore/createChatAction", {
        roomId: this.idRoom,
        callback: async (response) => {
          this.chats.unshift({
            id: response.data.id,
            title: response.data.title,
            createdAt: response.data.createdAt,
          });
          this.idChat = response.data.id;
          this.sendMessage(true);
        },
        callbackError: (error) => {
          console.log("TTT setMessage KO ", error);
          this.loading = false;
        },
      });
    } else this.sendMessage();
  }
  async sendMessage(firtTime = false) {
    const textMessage = this.text;
    this.responseText.push({ message: this.text, role: "user" });
    this.text = "";
    await this.$store.dispatch("HawkingsStore/fetchSendMessageChatAction", {
      data: {
        message: textMessage,
      },
      id: this.idChat,
      roomId: this.idRoom,
      callback: async (response) => {
        const reader = response.body.getReader();
        let isCreate = false;
        let itemToUpdate = null;
        // Función para leer y procesar los datos en tiempo real
        const read = async () => {
          const { done, value } = await reader.read();
          if (done) {
            this.updateScroll();
            await this.$store.dispatch("HawkingsStore/getQuestionsAction", {
              idChat: this.idChat,
              roomId: this.idRoom,
              callback: async (response) => {
                this.questions = response.data;
                this.typingBot = false;
                this.loading = false;
                setTimeout(() => {
                  this.updateScroll();
                }, 1);
              },
              callbackError: (error) => {
                this.typingBot = false;
                this.loading = false;
              },
            });
            if (firtTime) {
              setTimeout(async () => {
                await this.$store.dispatch(
                  "HawkingsStore/createTitleChatAction",
                  {
                    id: this.idChat,
                    roomId: this.idRoom,
                    callback: async (response) => {
                      let chat = this.chats.find(
                        (item) => item.id === response.data.id
                      );
                      chat.title = response.data.title;
                    },
                    callbackError: (error) => {
                      console.log("TTT createTitleChatAction KO ", error);
                    },
                  }
                );
              }, 2000);
            }
            return;
          }
          let message = new TextDecoder("utf-8").decode(value);
          const lines = message.split("\n\n");
          const parsedLines = lines
            .map((line) => line.replace(/^data: /, "").trim()) // Remove the "data: " prefix
            .filter((line) => line !== "" && line !== "[DONE]") // Remove empty lines and "[DONE]"
            .map((line) => {
              try {
                return JSON.parse(line);
              } catch (ex) {
                console.log("ERROR ", line);
              }
              return "";
            });

          for (const parsedLine of parsedLines) {
            if (!parsedLine) continue;
            const { content } = parsedLine;
            if (content === undefined) continue;
            if (!isCreate) {
              this.typingBot = true;
              isCreate = true;
              let id =
                this.responseText.length > 2
                  ? this.responseText[this.responseText.length - 2].id
                  : 0;
              id++;
              this.responseText.push({
                message: content,
                role: "assistant",
                id: id,
              });
              itemToUpdate = this.responseText.find((item) => item.id === id);
            }
            if (isCreate && itemToUpdate) {
              itemToUpdate.message = itemToUpdate.message + content;
            }
          }

          // Continúa leyendo los datos en tiempo real
          this.updateScroll()
          read();
        };

        read(); // Inicia la lectura de los datos
      },
      callbackError: (error) => {
        console.log("TTT KO ", error);
      },
    });

    //TODO Logica para pintar poco a poco el texto desde VUE
    /*await this.$store.dispatch("HawkingsStore/sendMessageChatAction", {
      data: {
        message: textMessage,
      },
      id: this.idChat,
      callback: async (response) => {
        let isCreate = false;
        let itemToUpdate = null;
        const cadenaSinData = response.data.replace(/data:/g, "");
        const responseMessage = cadenaSinData.split("\n");
        for (const message of responseMessage) {
          if (!isCreate) {
            isCreate = true;
            let id =
              this.responseText.length > 1
                ? this.responseText[this.responseText.length - 2].id
                : 0;
            let nextText = JSON.parse(message);
            this.responseText.unshift({
              message: nextText.content,
              role: "assistant",
              id: id,
            });
            itemToUpdate = this.responseText.find((item) => item.id === id);
          }
          if (isCreate && itemToUpdate) {
            let nexText =
              message.length > 0 && message.indexOf("DONE") === -1
                ? JSON.parse(message)
                : { content: "" };
            itemToUpdate.message = itemToUpdate.message + nexText.content;
          }
          await this.delay(100);
        }
        if (firtTime) {
          await this.$store.dispatch("HawkingsStore/createTitleChatAction", {
            id: this.idChat,
            callback: async (response) => {
              let chat = this.chats.find(
                (item) => item.id === response.data.id
              );
              chat.title = response.data.title;
            },
            callbackError: (error) => {
              console.log("TTT createTitleChatAction KO ", error);
            },
          });
        }
        this.loading = false;
      },
      callbackError: (error) => {
        console.log("TTT sendMessage KO ", error);
        this.loading = false;
      },
    });*/
  }
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  async getChatHistory(idChat: number, isClear: boolean) {
    this.idChat = idChat;
    if (isClear) {
      this.currentPage = 1;
      this.lastPage = 0;
    }
    await this.$store.dispatch("HawkingsStore/getChatHistoryAction", {
      idChat: idChat,
      page: this.currentPage,
      roomId: this.idRoom,
      callback: (response) => {
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        if (this.currentPage == 1) {
          this.responseText = [];
          this.responseText = response.data;
        } else {
          this.responseText.push(...response.data);
        }
        setTimeout(() => {
          this.loadHistory = false;
        }, 500);
      },
      callbackError: (error) => {
        this.loadHistory = false;
        console.log("TTT sendMessage KO ", error);
      },
    });
  }
  newChat() {
    this.currentPage = 1;
    this.responseText = [];
    if (this.welcome != null && this.responseText.length === 0)
      this.responseText.push({
        message: this.welcome,
        role: "assistant",
        id: -1,
      });
    this.idChat = null;
    this.questions = [];
  }
  checkSeparationChat(time: string, id: string): boolean {
    const date = moment(time);

    const today = moment().startOf("day");
    if (moment(date).isSame(today, "d")) {
      if (!this.idToday) this.idToday = id;
      return true;
    }

    const yesterday = moment().subtract(1, "days").startOf("day");
    if (moment(date).isSame(yesterday, "d")) {
      if (!this.idYesterday) this.idYesterday = id;
      return true;
    }

    const data = {
      id: id,
      date: moment(time).format("L"),
    };
    const i = this.idDays.findIndex((e) => e.date === moment(time).format("L"));
    if (i == -1) this.idDays.push(data);
    return true;
  }
  close() {
    this.active = false;
    this.currentPage = 1;
    this.currentPageChats = 1;
    this.responseText = [];
    this.chats = [];
    this.text = "";
    this.name = "";
    this.description = "";
    this.idRoom = 0;
    this.idChat = null;
    this.idToday = null;
    this.idYesterday = null;
    this.idDays = [];
    this.questions = [];
    this.welcomeQuestions = [];
  }
  copy(message): void {
    if (message.length <= 0) return;
    const cb = navigator.clipboard;
    cb.writeText(message).then(() =>
      this.onDefault("", this.$i18n.t("hawkings.messageCopiedClipboard"))
    );
  }
  sendQuestion(message: string) {
    if (!message) return;
    this.text = message;
    this.setMessage();
  }
  updateScroll () {
    let chatContainer = document.getElementById("body-scroll");
    chatContainer.scrollTop = chatContainer.scrollHeight;
  }
}
